var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"profile-image",style:(_vm.imgStyle),attrs:{"alt":"Profile Picture","src":_vm.cacheBustingUrl}})}
var staticRenderFns = []

export { render, staticRenderFns }